import React, { useState, useEffect } from 'react';
import { Typography, Space } from 'antd';
import CustomSpinner from './CustomSpinner';
import ImageComponent from './ImageComponent';
import useImageService from '../hooks/useImageServices';
import './css/PresentationTab.css';  // or wherever your .css lives

const { Text } = Typography;

function ImageLoader({ realmObject }) {
  const { error, fetchImageBlob } = useImageService();
  const [imageBlob, setImageBlob] = useState(null);
  const [selfLoad, setSelfLoad] = useState({ serviceID: null, objectID: null });
  const [imageAvailable, setImageAvailable] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function load() {
      if (realmObject?.payload?.images?.length > 0) {
        setImageAvailable(true);
        const serviceID = realmObject.RealmID;
        const objectID  = realmObject.RealmObjectID;
        setSelfLoad({ serviceID, objectID });

        setLoading(true);
        try {
          const blob = await fetchImageBlob(serviceID, objectID);
          setImageBlob(blob || null);
        } catch (err) {
          console.error('Error fetching image:', err);
          setImageBlob(null);
        } finally {
          setLoading(false);
        }
      } else {
        setImageAvailable(false);
        setSelfLoad({ serviceID: null, objectID: null });
        setImageBlob(null);
      }
    }

    load();
  }, [realmObject, fetchImageBlob]);

  return (
    <Space direction="vertical" align="center" style={{ width: '100%' }}>
      {error && error.statusCode !== 404 ? (
        error.statusCode === 403 ? (
          <Text className="text-primary">
            Image is being checked for security, check back in a while.
          </Text>
        ) : (
          <Text className="text-primary">
            Unable to load the image right now.
          </Text>
        )
      ) : imageAvailable ? (
        <div className="image-loader-container">
          {loading ? (
            <CustomSpinner />
          ) : (
            <ImageComponent
              key={selfLoad.objectID}
              imageKey={selfLoad.objectID}
              blob={imageBlob}
            />
          )}
        </div>
      ) : null}
    </Space>
  );
}

export default ImageLoader;
